import React from 'react';
import './Contact.css';

const ContactUs = () => {
  return (
    <section className="contact-page">
      <div className="contact-container">
        <h1>Contact Revora</h1>
        <p className="contact-subtext">
          Have questions or feedback? Let’s connect — we’re here to assist you with passion and precision.
        </p>

        <form className="contact-form">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" required></textarea>
          <button type="submit" className="contact-btn">Send Message</button>
        </form>

        <div className="contact-details">
          <h3>Reach Us</h3>
          <p><span>Email:</span> revora.official01@gmail.com</p>
          <p><span>Phone:</span> +91 98154 16752</p>
          <p><span>Location:</span> Chandigarh, India</p>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
